import { DESTINATIONS } from "@/data/content";

export default function Marquee() {
  const items = DESTINATIONS.slice(0, 7).map((d) => d.name);
  const Row = ({ hidden = false }) => (
    <div className="flex shrink-0 items-center" aria-hidden={hidden}>
      {items.map((name) => (
        <span key={name} className="flex items-center">
          <span className="whitespace-nowrap px-8 font-display text-2xl italic text-gold-light md:px-12 md:text-3xl">
            {name}
          </span>
          <span className="h-1.5 w-1.5 rotate-45 bg-gold/60" aria-hidden="true" />
        </span>
      ))}
    </div>
  );

  return (
    <div
      data-testid="marquee-band"
      className="overflow-hidden border-y border-forest/10 bg-cream py-6"
    >
      <div className="marquee-track">
        <Row />
        <Row hidden />
      </div>
    </div>
  );
}
